import { useI18n } from '~/app/i18n/i18n';

export const SeatFallbackSvg = () => {
	const { i18n } = useI18n();
	return (
		<svg
			role="img"
			aria-label={i18n('ngc.a11y.placeholderImage')}
			width="41"
			height="57"
			viewBox="-4 -4 49 65"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M34.8 23.49C34.8 23.49 28.84 26.55 28.84 42.85C28.84 42.85 36.34 45.2 36.34 48.6C36.34 48.6 33.32 52.62 29.97 56.66M33 24.05L33.14 23.27C33.14 18.02 29.37 13.76 24.71 13.76H15.62C10.97 13.76 7.19 18.02 7.19 23.27L7.33 24.05M8.98001 18.14L10.87 20.48C13.54 26.29 14.93 32.61 14.93 39V42.86M31.37 18.14L29.48 20.48C26.81 26.29 25.42 32.61 25.42 39V42.86M25.42 42.86H14.92L12.38 44.56C11.6 45.08 11.97 46.3 12.91 46.3H27.43C28.37 46.3 28.74 45.08 27.96 44.56L25.42 42.86ZM12.29 23.49L14.88 22.8C18.34 21.88 21.99 21.88 25.45 22.8L28.04 23.49M5.55 23.49C5.55 23.49 11.51 26.55 11.51 42.85C11.51 42.85 4.01 45.2 4.01 48.6C4.01 48.6 7.03 52.62 10.38 56.66M0.98 48.6L13.37 50.42C17.88 51.08 22.47 51.08 26.98 50.42L39.37 48.6M13.41 10.18C13.41 10.18 11.82 2.23 15.26 0.620001M26.93 10.18C26.93 10.18 28.52 2.23 25.08 0.620001M16.98 0.25H23.36C25.98 0.25 28.11 2.38 28.11 5V8.55C28.11 9.6 27.26 10.45 26.21 10.45H14.13C13.08 10.45 12.23 9.6 12.23 8.55V5C12.23 2.38 14.36 0.25 16.98 0.25ZM6.58 42.86H33.75L34.79 22.12C34.79 16.87 30.54 12.62 25.29 12.62H15.04C9.79 12.62 5.54 16.87 5.54 22.12L6.58 42.86ZM39.85 48.68L34.98 55.83C34.63 56.35 34.04 56.66 33.41 56.66H6.93C6.3 56.66 5.71 56.35 5.36 55.83L0.49 48.68C0.17 48.21 0.17 47.59 0.49 47.12C1.26 45.97 2.3 45.04 3.53 44.41L6.58 42.85H33.77L36.82 44.41C38.05 45.04 39.09 45.97 39.86 47.12C40.18 47.59 40.17 48.21 39.86 48.68H39.85Z"
				stroke="#B3B3B3"
				strokeWidth="0.41"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
		</svg>
	);
};
